<template>
    <div id="contact" class="mt-24 bg-white">
        <div class="flex flex-wrap items-start justify-center md:p-0 xs:p-4">
            <div class="md:w-1/3 xs:w-full text-main-black">
                <h1 class="text-main-black font-semibold text-2xl">
                    Contact with us
                </h1>
                <div
                    class="mt-8 opacity-50 lg:text-base xs:text-sm md:w-3/4 xs:w-full"
                >
                    Feel free to reach out to us at any time to share your
                    thoughts, report issues, or provide feedback. Our team is
                    dedicated to assisting you and will respond to your messages
                    promptly.
                </div>

                <div class="flex items-center mt-2 opacity-50">
                    <img src="./../assets/mail.svg" alt="" class="h-4 mr-2" />
                    <a
                        href="mailto:luyao@ruyicode.com"
                        class="no-underline text-base text-main-green"
                        >luyao@ruyicode.com</a
                    >
                </div>
            </div>
            <div class="md:w-1/3 xs:w-full md:mt-0 xs:mt-6">
                <form action="#" method="post" class="" v-on:submit.prevent>
                    <div class="md:hidden xs:block text-extrabold mt-6 mb-4">
                        Send us a message
                    </div>

                    <div class="mb-6">
                        <span v-if="error.nameEmpty">
                            <input
                                v-model="name"
                                type="text"
                                placeholder="Your name"
                                class="w-full border border-red-light bg-grey-lightest py-4 text-main-black font-medium text-base text-center focus:bg-grey-light focus:outline-none mr-2"
                            />
                            <span
                                class="text-main-black font-semibold text-xs opacity-75"
                            >
                                You should enter your name before sumbiting your
                                message
                            </span>
                        </span>
                        <span v-else>
                            <input
                                v-model="name"
                                type="text"
                                placeholder="Your name"
                                class="w-full bg-grey-lightest py-4 text-main-black font-medium text-base text-center focus:bg-grey-light focus:outline-none mr-2"
                            />
                        </span>
                    </div>

                    <div class="mb-6">
                        <span v-if="error.emailEmpty">
                            <input
                                v-model="email"
                                type="text"
                                placeholder="Your email"
                                class="w-full border border-red-light bg-grey-lightest py-4 text-main-black font-medium text-base text-center focus:bg-grey-light focus:outline-none"
                            />
                            <span
                                class="text-main-black font-semibold text-xs opacity-75"
                            >
                                You should enter your email before sumbiting
                                your message
                            </span>
                        </span>

                        <span v-else>
                            <span v-if="error.emailWrong">
                                <input
                                    v-model="email"
                                    type="text"
                                    placeholder="Your email"
                                    class="w-full border border-red-light bg-grey-lightest py-4 text-main-black font-medium text-base text-center focus:bg-grey-light focus:outline-none"
                                />
                                <span
                                    class="text-main-black font-semibold text-xs opacity-75"
                                >
                                    You should enter a valid email address
                                </span>
                            </span>
                            <span v-else>
                                <input
                                    v-model="email"
                                    type="text"
                                    placeholder="Your email"
                                    class="w-full bg-grey-lightest py-4 text-main-black font-medium text-base text-center focus:bg-grey-light focus:outline-none"
                                />
                            </span>
                        </span>
                    </div>

                    <div class="mb-6">
                        <span v-if="error.messageBodyEmpty">
                            <textarea
                                v-model="messageBody"
                                placeholder="Your Message"
                                class="w-full border border-red-light bg-grey-lightest py-16 text-main-black font-medium text-base text-center focus:bg-grey-light focus:outline-none"
                            ></textarea>
                            <span
                                class="text-main-black font-semibold text-xs opacity-75"
                            >
                                You should enter a something before sumbiting
                                your message
                            </span>
                        </span>

                        <span v-else>
                            <textarea
                                v-model="messageBody"
                                placeholder="Your Message"
                                class="w-full bg-grey-lightest py-16 text-main-black font-medium text-base text-center focus:bg-grey-light focus:outline-none"
                            ></textarea>
                        </span>
                    </div>

                    <div class="w-full md:text-right xs:text-center">
                        <button
                            @click="checkForm"
                            class="bg-main-green px-4 py-4 rounded font-medium text-center xs:w-full lg:w-auto text-grey-lightest"
                        >
                            Send Message
                        </button>
                    </div>

                    <!-- <button class="bg-yellow-dark uppercase px-4 py-4 rounded font-black text-yellow-darker border-b-4 border-yellow-darker mb-4">Create -->
                    <!-- my account</button> -->
                </form>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            error: {
                nameEmpty: false,
                emailEmpty: false,
                emailWrong: false,
                messageBodyEmpty: false,
                database: false,
            },
            name: null,
            email: null,
            messageBody: null,
        };
    },
    computed: {
        hasNoErrors() {
            return (
                !this.error.nameEmpty &&
                !this.error.emailEmpty &&
                !this.error.emailWrong &&
                !this.error.messageBodyEmpty
            );
        },
    },
    methods: {
        emailValidation(email) {
            var re =
                /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        },

        checkForm() {
            if (!this.name) {
                this.error.nameEmpty = true;
            } else {
                this.error.nameEmpty = false;
            }

            if (!this.email) {
                this.error.emailEmpty = true;
            } else {
                if (this.emailValidation(this.email)) {
                    this.error.emailWrong = false;
                } else {
                    this.error.emailWrong = true;
                }
                this.error.emailEmpty = false;
            }

            if (!this.messageBody) {
                this.error.messageBodyEmpty = true;
            } else {
                this.error.messageBodyEmpty = false;
            }

            if (this.hasNoErrors) {
                this.submitMessage();
            }
        },

        submitMessage() {
            this.customEmail();
        },

        customEmail() {
            window.open(
                `mailto:test@example.com?subject=${this.name}&body=${this.messageBody}`,
            );
        },

        resetForm() {
            this.name = null;
            this.email = null;
            this.messageBody = null;
        },
    },
    mounted() {},
};
</script>

<style scoped></style>
